document.addEventListener('DOMContentLoaded', function () {
const tabs = document.querySelectorAll('.cta-tabs .tabs-nav button');
const contents = document.querySelectorAll('.cta-tabs .tab-content');
const tabsWrapper = document.querySelector('.cta-tabs__wrapper');
let currentBackground = '';
tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => {
        document.querySelector('.cta-tabs .tabs-nav button.active').classList.remove('active');
        document.querySelector('.cta-tabs .tab-content.active').classList.remove('active');
        tab.classList.add('active');
        contents[idx].classList.add('active');
        currentBackground = document.querySelector('.cta-tabs .tabs-nav .active').dataset.bg;
        if(currentBackground != '') {
            tabsWrapper.style.backgroundImage = `url(${currentBackground})`;
        }
    });
});

if (tabs.length > 0) {
    tabs[0].classList.add('active');
    contents[0].classList.add('active');
    currentBackground = document.querySelector('.cta-tabs .tabs-nav .active').dataset.bg;

    if(currentBackground != '') {
       tabsWrapper.style.backgroundImage = `url(${currentBackground})`;
    }
}
});